import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme/theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box id="headerBox" mb="16px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ m: "10px 0 5px 0" }}
      >
        {title}
      </Typography>
      <Typography variant="h5" color={colors.greenAccent[300]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;